import { useEffect, useRef, useState } from 'react';
import DataDog, { sendEventRUM } from '../../Helpers/DataDog';
import { RecodeBase64SpecialChars } from '../../Helpers/RecodeBase64SpecialChars';
import UpdateCookies from '../../Helpers/UpdateCookies';
import useActualizarNewsletter from '../../Hooks/useActualizarNewsletter';
import useObtenerServiciosNewsletter from '../../Hooks/useObtenerServiciosNewsletter';
import GetParamURL from '../../Helpers/GetParamURL';
import hardcodeDomicilioParaCompraClubExterior from '../../Config/hardcodeDomicilioParaCompraClubExterior';

const WondersoftFormIframe = (props) => {
    const PROCESAR_PAGO_MAX_RETRY = 2;
    const { correlationId, dataVenta, procesarPago, state, send, setIsLoadingWs, errorPagoWs, setErrorPagoWs, setPaid } = props;
    const planes = state.context?.planCampania?.planes;
    const [_, errorObtenerServicios, isLoadingObtenerServicios, obtenerServiciosNewsletter] = useObtenerServiciosNewsletter();
    const [__, errorActualizarServ, isLoadingActualizarServ, actualizarNewsletter] = useActualizarNewsletter();
    const formRef = useRef();
    const informaDomicilio = state.context?.planCampania.planes[0].informaDomicilio;
    const residenciaArg = state.context.datosPersonales.residencia == 'Argentina';
    const isPlanAnual = state.context.datosCarrito.isPlanAnual;
    let retry = 0;

    useEffect(() => {
        window.addEventListener('message', handleMessageReceived);
        return () => {
            window.removeEventListener('message', handleMessageReceived);
        };
    }, []);

    const urlParams = GetParamURL();

    const handleMessageReceived = (event) => {
        if(event?.data === "PaymentFormSubmit"){
            DD_LOGS.logger.info("customEvent", {
                eventData: {
                  evento: "loggventa",
                  correlationId: correlationId,
                  step: {
                    nombre: "click-on-submit-payment",
                  },
                },
              });
        }
        if (errorPagoWs) {
            return;
        }

        const eventData = event?.data?.data;
        const rta = eventData?.Codrta;
        rta == '1173-00' && console.warn('1173-00 for correlation:', correlationId);
        if (rta && dataVenta) {
            setIsLoadingWs(true);
            const hashConvertido = RecodeBase64SpecialChars(eventData?.hash);
            const passConvertida = RecodeBase64SpecialChars(eventData?.password);
            const tokenConvertido = RecodeBase64SpecialChars(eventData?.token);
            const token_da_Convertido = RecodeBase64SpecialChars(eventData?.token_da);
            const payload = {
                SitioOrigen: dataVenta.SitioOrigen,
                CorrelationId: correlationId,
                Codrta: rta,
                Descripcion: eventData?.Descripcion,
                hash: hashConvertido,
                password: passConvertida,
                mascara: eventData?.mascara,
                token: tokenConvertido,
                token_da: token_da_Convertido,
                esExtranjero: dataVenta.domicilioModel?.domicilioExtranjero,
                planId: dataVenta.planId,
                campaniaId: dataVenta.campaniaId,
                paginaId: '',
                importeEtapas: {
                    cantidadMesesPrimeraEtapa: isPlanAnual ? 0 : planes[0].mesesDescuento,
                    importePrimeraEtapa: isPlanAnual ? 0 : planes[0].precio,
                    importeSegundaEtapa: isPlanAnual ? 0 : planes[0].precioSinDescuento,
                },
            };
            // para codigo de rta != 1174-00 igualmente queremos hacer el procesamiento del pago
            // porque podríamos necesitar cerrar una venta iniciada con iniciarVenta como error
            procesarPago(payload)
                .then(async (resp) => {
                    const venta = resp.response;
                    const domicilioHardcoded = {
                        IdCanalVenta: parseInt(urlParams.canalDeVenta),
                        PlanId: state.context.planCampania.id,
                        CorrelationId: correlationId,
                        EditarDomicilio: hardcodeDomicilioParaCompraClubExterior,
                    };
                    switch (resp.code) {
                        case '0000':
                            domicilioHardcoded.EditarDomicilio.addressId = venta?.ventaResponse?.AddressId;
                            postPagoDD();
                            // await UpdateCookies();
                            //se activa newsletter
                            obtenerServiciosNewsletter().then((respuesta) => {
                                if (respuesta.code === '0') {
                                    actualizarNewsletter([30]);
                                }
                                setIsLoadingWs(false);
                                if (residenciaArg) {
                                    if(informaDomicilio)
                                        send('CONTINUARARGENTINO', { dataVenta: venta });
                                    else
                                        send('CONTINUARNOINFORMA', { dataVenta: venta });
                                } else {
                                    DataDog.trackCustomEvent('venta-domicilio-exterior', {
                                        IdCanalVenta: parseInt(urlParams.canalDeVenta),
                                        PlanId: state.context.planCampania.id,
                                        CorrelationId: correlationId,
                                        Exterior: true,
                                    });
                                    send('CONTINUAREXTRANJERO', { dataDomicilio: domicilioHardcoded });
                                }
                                //movi if que contiene send afuera del if code = 0, si falla deberia igual continuar?
                            });
                            break;
                        case '0003':
                            if (rta == '1174-00') {
                                postPagoDD();
                                // await UpdateCookies();
                                obtenerServiciosNewsletter();
                                setIsLoadingWs(false);
                                send('CONTINUARVENTABACKGROUND', { dataVenta: venta });
                            } else {
                                // si obtengo '0003' de procesarPago no quiero continuar con venta background
                                // para el caso de una venta con respuesta != 1174-00
                                setPaymentError();
                            }
                            break;
                        case '0001':
                            setPaymentError();
                            break;
                        default:
                            setPaymentError();
                            break;
                    }
                })
                .catch((error) => {
                    // si la respuesta no es success ni me calienta
                    if (rta == '1174-00') {
                        // trato una única vez más porque éste error mata el proceso de asignación de la suscripción
                        // a un usuario que ya pagó y se le cobró correctamente
                        if (retry < PROCESAR_PAGO_MAX_RETRY) {
                            retry++;
                            console.warn("Failed to fetch, will retry...");
                            handleMessageReceived(event);
                        }
                        else{
                            console.error("Critical - failed to fetch payment response. Won't try again:", error);
                            setPaymentError();
                        }
                    } else {
                        setPaymentError();
                    }
                });
        } else {
            if (rta) {
                // si llegó hasta acá y tiene código de respuesta entonces lo que falta es la data
                setPaymentError();
            }
            // si no tiene codigo de respuesta es un event que no nos interesa
        }
    };

    const setPaymentError = () => {
        setIsLoadingWs(false);
        setErrorPagoWs(true);
        setPaid(true);
    };

    const postPagoDD = () => {
        sendEventRUM('Confirma Pago');
        DataDog.trackCustomEvent('venta', {
            canalDeVenta: state.context?.canalDeVenta,
            formaDeContacto: state.context?.formaDeContacto,
            planId: state.context?.planCampania.id,
        });
    };

    useEffect(() => {
        writeHtml(props);
    }, [props.ActionUrl]);

    const writeHtml = (data) => {
        const { ActionUrl, Hash, Password, RedirectUrl, Token, TipoTransaccion } = data;
        const form = document.createElement('form');
        form.method = 'post';
        form.action = ActionUrl;
        form.target = 'ws-iframe';

        const params = {
            HASH: Hash,
            PASSWORD: Password,
            URLREDIRECCION: RedirectUrl,
            TOKEN: Token,
            TIPOTRAN: TipoTransaccion,
        };

        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                const hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = key;
                hiddenField.value = params[key];

                form.appendChild(hiddenField);
            }
        }

        document.body.appendChild(form);
        formRef.current.innerHTML = form.submit();
    };

    return (
        <>
            <iframe name="ws-iframe" height={360} width={500} ref={formRef}></iframe>
        </>
    );
};

export default WondersoftFormIframe;
